import Turbolinks from 'turbolinks';
const serialize = require('form-serialize');

import { Controller } from 'stimulus';

export default class extends Controller {
  initialize() {
    this.element.addEventListener('submit', (event) => {
      event.preventDefault();
      this.submit();
    });
  }

  submit() {
    Turbolinks.visit(this.element.action + '?' + serialize(this.element));
  }

  selectSwitch(event) {
    const input = this.element.querySelector('input[name="' + event.target.dataset.field + '"]');
    input.disabled = false;
    input.value = event.target.dataset.value;

    this.submit();
  }
}
